/* Strike Gently idea board: loads the board from the Idea Board app proxy */
(function () {
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function ago(iso) {
    var s = (Date.now() - Date.parse(iso)) / 1000;
    if (!isFinite(s)) return '';
    if (s < 3600) return Math.max(1, Math.round(s / 60)) + 'm ago';
    if (s < 86400) return Math.round(s / 3600) + 'h ago';
    if (s < 86400 * 30) return Math.round(s / 86400) + 'd ago';
    return Math.round(s / (86400 * 30)) + 'mo ago';
  }

  function init(root) {
    if (root.dataset.ibReady) return;
    root.dataset.ibReady = '1';

    var proxy = (root.dataset.proxy || '/apps/ideas').replace(/\/+$/, '');
    var loginUrl = root.dataset.loginUrl;
    if (location.search && loginUrl) {
      // Come back to this exact URL after logging in, query string included.
      loginUrl = loginUrl.split('?')[0] + '?return_to=' + encodeURIComponent(location.pathname + location.search);
      var loginLink = root.querySelector('.idea-board__login a');
      if (loginLink) loginLink.href = loginUrl;
    }
    var loggedIn = root.dataset.loggedIn === 'true';
    var $ = function (sel) { return root.querySelector(sel); };
    var list = $('[data-ib-list]');
    var empty = $('[data-ib-empty]');
    var more = $('[data-ib-more]');
    var boardStatus = $('[data-ib-board-status]');
    var state = { sort: 'top', offset: 0, req: 0, ideas: new Map() };

    function api(path, body) {
      var opts = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
      if (body) {
        opts.method = 'POST';
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(body);
      }
      return fetch(proxy + path, opts)
        .then(function (r) { return r.json(); })
        .catch(function () { return { ok: false, error: 'network' }; });
    }

    function say(target, message, linkHref) {
      if (!target) return;
      target.textContent = '';
      if (!message) return;
      if (linkHref) {
        var a = el('a', '', 'log in');
        a.href = linkHref;
        target.append(a, ' ' + message);
      } else {
        target.textContent = message;
      }
    }

    function paint(li, idea) {
      var score = li.querySelector('.idea-board__score');
      score.textContent = idea.score;
      score.setAttribute('aria-label', idea.score + (Math.abs(idea.score) === 1 ? ' point' : ' points'));
      li.querySelector('[data-dir="1"]').setAttribute('aria-pressed', idea.my_vote === 1 ? 'true' : 'false');
      li.querySelector('[data-dir="-1"]').setAttribute('aria-pressed', idea.my_vote === -1 ? 'true' : 'false');
    }

    function row(idea) {
      var li = el('li', 'idea-board__item');
      li.dataset.id = idea.id;
      var vote = el('div', 'idea-board__vote');
      var up = el('button', 'idea-board__arrow idea-board__arrow--up', '▲');
      up.type = 'button';
      up.dataset.dir = '1';
      up.setAttribute('aria-label', 'upvote');
      var down = el('button', 'idea-board__arrow idea-board__arrow--down', '▼');
      down.type = 'button';
      down.dataset.dir = '-1';
      down.setAttribute('aria-label', 'downvote');
      vote.append(up, el('span', 'idea-board__score'), down);

      var body = el('div', 'idea-board__body');
      body.append(el('p', 'idea-board__title', idea.title));
      if (idea.details) body.append(el('p', 'idea-board__details', idea.details));
      var meta = [];
      if (idea.rank) meta.push('#' + idea.rank);
      meta.push(idea.credit);
      if (idea.approved_at) meta.push(ago(idea.approved_at));
      if (idea.mine) meta.push('yours');
      body.append(el('p', 'idea-board__meta', meta.join(' · ')));

      li.append(vote, body);
      paint(li, idea);
      return li;
    }

    function renderPrize(res) {
      var tpl = root.dataset.prizeLine;
      var target = $('[data-ib-prize]');
      if (!tpl || !target) return;
      target.textContent = tpl
        .replace(/\{count\}/g, res.winners_per_month)
        .replace(/\{prize\}/g, res.prize)
        .replace(/\{date\}/g, res.next_close_label);
      target.hidden = false;
    }

    function renderMe(me) {
      var remaining = $('[data-ib-remaining]');
      var submit = $('[data-ib-submit]');
      if (remaining) {
        remaining.textContent = me.remaining > 0
          ? me.remaining + ' of ' + me.limit + ' ideas left this month.'
          : "that's your " + me.limit + ' for this month. more on the 1st.';
      }
      if (submit) submit.disabled = me.remaining <= 0;
      // The private question shows until they've answered it once.
      var why = $('[data-ib-why]');
      if (why) why.hidden = me.why_answered !== false;
      var box = $('[data-ib-pending]');
      var ul = $('[data-ib-pending-list]');
      if (box && ul) {
        ul.textContent = '';
        (me.pending || []).forEach(function (p) { ul.append(el('li', '', p.title)); });
        box.hidden = !(me.pending && me.pending.length);
      }
    }

    function renderWinners(rounds) {
      var wrap = $('[data-ib-winners]');
      var box = $('[data-ib-winners-list]');
      if (!wrap || !box) return;
      box.textContent = '';
      rounds.forEach(function (r) {
        var block = el('div', 'idea-board__round');
        block.append(el('p', 'idea-board__subheading', r.label));
        var ul = el('ul', 'idea-board__winner-list');
        r.ideas.forEach(function (w) { ul.append(el('li', '', w.title + ' — ' + w.credit + ' (' + w.score + ')')); });
        block.append(ul);
        box.append(block);
      });
      wrap.hidden = rounds.length === 0;
    }

    function load(reset) {
      var token = ++state.req;
      if (reset) {
        state.offset = 0;
        say(boardStatus, 'loading…');
      }
      more.hidden = true;
      api('/list?sort=' + state.sort + '&offset=' + state.offset).then(function (res) {
        if (token !== state.req) return;
        if (!res || !res.ok) {
          say(boardStatus, "the board didn't load. refresh to try again.");
          return;
        }
        say(boardStatus, '');
        if (reset) {
          list.textContent = '';
          state.ideas.clear();
        }
        if (res.logged_in === false) loggedIn = false;
        res.ideas.forEach(function (idea) {
          if (state.ideas.has(idea.id)) return;
          state.ideas.set(idea.id, idea);
          list.append(row(idea));
        });
        state.offset = res.next_offset;
        more.hidden = !res.has_more;
        empty.hidden = list.children.length > 0;
        if ('next_close_label' in res) renderPrize(res);
        if (res.winners) renderWinners(res.winners);
        if (res.me) renderMe(res.me);
      });
    }

    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.idea-board__arrow');
      if (!btn) return;
      var li = btn.closest('.idea-board__item');
      var idea = state.ideas.get(Number(li.dataset.id));
      if (!idea) return;
      if (!loggedIn) {
        say(boardStatus, 'to vote.', loginUrl);
        return;
      }
      if (idea.busy) return;
      var dir = Number(btn.dataset.dir);
      var next = idea.my_vote === dir ? 0 : dir;
      var before = { score: idea.score, my_vote: idea.my_vote };
      idea.score = idea.score - idea.my_vote + next;
      idea.my_vote = next;
      idea.busy = true;
      paint(li, idea);
      api('/vote', { id: idea.id, value: next }).then(function (res) {
        idea.busy = false;
        if (res.ok) {
          idea.score = res.score;
          idea.my_vote = res.my_vote;
          paint(li, idea);
          return;
        }
        idea.score = before.score;
        idea.my_vote = before.my_vote;
        paint(li, idea);
        if (res.error === 'login_required') {
          loggedIn = false;
          say(boardStatus, 'to vote.', loginUrl);
        } else if (res.error === 'closed') {
          say(boardStatus, 'voting on that one just closed.');
        } else {
          say(boardStatus, "couldn't save that vote. try again.");
        }
      });
    });

    root.querySelectorAll('[data-ib-sort]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (state.sort === tab.dataset.ibSort) return;
        state.sort = tab.dataset.ibSort;
        root.querySelectorAll('[data-ib-sort]').forEach(function (t) {
          t.setAttribute('aria-pressed', t === tab ? 'true' : 'false');
        });
        load(true);
      });
    });
    more.addEventListener('click', function () { load(false); });

    var form = $('[data-ib-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var status = $('[data-ib-form-status]');
        var button = $('[data-ib-submit]');
        var field = function (name) { return form.querySelector('[name="' + name + '"]'); };
        var why = field('why');
        var data = {
          title: field('title').value.trim(),
          details: field('details').value.trim(),
          credit: field('credit').value.trim(),
          why: why ? why.value.trim() : ''
        };
        if (data.title.length < 3) {
          say(status, 'give your idea a title first.');
          field('title').focus();
          return;
        }
        button.disabled = true;
        say(status, 'sending…');
        api('/submit', data).then(function (res) {
          button.disabled = false;
          if (res.ok) {
            field('title').value = '';
            field('details').value = '';
            if (why) why.value = '';
            say(status, "got it. it'll show up here once it's approved.");
          } else if (res.error === 'login_required') {
            say(status, 'to pitch an idea.', loginUrl);
          } else {
            say(status, {
              limit_reached: "that's your limit for this month. more on the 1st.",
              duplicate: 'you already pitched that one.',
              invalid: res.message || 'check your idea and try again.'
            }[res.error] || 'something broke. try again in a sec.');
          }
          if (res.me) renderMe(res.me);
        });
      });
    }

    load(true);
  }

  function start() {
    document.querySelectorAll('.idea-board[data-proxy]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();